import MainTabs from './MainTabs';

export default MainTabs;
